import { HOST } from "../constants/HostConstants";

export const commentApprove = async (report_id) => {
  try {
    const res = await fetch(`${HOST}/api/comment/commentApprove`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ report_id }),
    });
    const data = await res.json();
    return data;
  } catch (err) {
return { success: false, error: err.message };
  }
};
